export default __webpack_public_path__ + "static/media/Border.39b20d03.svg";